const SILENT_DEVICE_PRIORITY_VALUES = [36, 195];

export const sameAlertId = (a, b) => (a ?? null) === (b ?? null);

const answeredBy = (subject, userId) =>
  !!subject?.officersRespondedToCritical?.some(
    (officer) => officer?.user === userId,
  );

export function diffForAlerts(prevSubjects, nextSubjects, { userId } = {}) {
  const previousById = new Map(
    (prevSubjects || [])
      .filter(Boolean)
      .map((subject) => [subject.id, subject]),
  );
  const missedCriticals = [];
  const missedDevice = [];
  const changedAlertIds = [];

  (nextSubjects || []).forEach((next) => {
    if (!next) return;
    const previous = previousById.get(next.id);
    const wasHigh = previous?.wellnessCategory === "High";

    if (next.wellnessCategory === "High") {
      const alertChanged =
        wasHigh && !sameAlertId(previous.alertId, next.alertId);
      if (alertChanged) changedAlertIds.push(next.id);
      if ((!wasHigh || alertChanged) && !answeredBy(next, userId)) {
        missedCriticals.push(next);
      }
    }

    if (
      next.wellnessCategory === "Device" &&
      previous?.priorityValue !== next.priorityValue &&
      !SILENT_DEVICE_PRIORITY_VALUES.includes(next.priorityValue)
    ) {
      missedDevice.push(next);
    }
  });

  return { missedCriticals, missedDevice, changedAlertIds };
}
